export function onChangeLanguage(state, payload) {
    return {
        ...state,
        selectedLanguage: payload.language
    };
};